var map = {
	"./GoogleCalendar.svg": 82233,
	"./Hipercard.png": 57416,
	"./WhatsApp.svg": 25436,
	"./areamanager/areamanager-bg.jpg": 67893,
	"./avatar-john.png": 28026,
	"./avatar-julia.png": 7744,
	"./avatar-kevin.png": 78257,
	"./avatar.png": 46855,
	"./avatar/avatar.png": 34185,
	"./avatar/avatar1.png": 41415,
	"./avatar/avatar2.png": 66839,
	"./avatar/avatar3.png": 76821,
	"./avatar/avatar4.png": 65210,
	"./background.png": 19932,
	"./backgroundConfimea.jpg": 52518,
	"./backgroundHeader.png": 19875,
	"./backgroundPatternConfimea.png": 5689,
	"./businessSquareLogo.jpeg": 47080,
	"./businessSquareLogo.png": 12956,
	"./businesspartner/businesspartner-bg.jpg": 47108,
	"./businesspartner/businesspartner-bg.jpg~": 2138,
	"./cart-full.png": 67805,
	"./cart-full.svg": 2526,
	"./cart.png": 46116,
	"./cart.svg": 20007,
	"./checkmark.svg": 77856,
	"./configurator/layout/aloe.png": 59448,
	"./configurator/layout/aqua.png": 82014,
	"./configurator/layout/bangkok.png": 50749,
	"./configurator/layout/canvas.png": 98368,
	"./configurator/layout/cross.png": 33743,
	"./configurator/layout/deeppurple.png": 21449,
	"./configurator/layout/dream.png": 77462,
	"./configurator/layout/emerald.png": 74884,
	"./configurator/layout/focus.png": 951,
	"./configurator/layout/forest.png": 98959,
	"./configurator/layout/fractal.png": 33708,
	"./configurator/layout/gem.png": 1055,
	"./configurator/layout/green.png": 62091,
	"./configurator/layout/indigo.png": 44264,
	"./configurator/layout/joshua.png": 28560,
	"./configurator/layout/laser.png": 41893,
	"./configurator/layout/lime.png": 30911,
	"./configurator/layout/maze.png": 59477,
	"./configurator/layout/metro.png": 25521,
	"./configurator/layout/milan.png": 8964,
	"./configurator/layout/night.png": 95831,
	"./configurator/layout/osterreich.png": 86784,
	"./configurator/layout/palm.png": 46268,
	"./configurator/layout/petroleum.png": 52234,
	"./configurator/layout/rose.png": 42514,
	"./configurator/layout/sand.png": 16418,
	"./configurator/layout/steel.png": 3831,
	"./configurator/layout/summer.png": 38314,
	"./configurator/layout/turquoise.png": 30459,
	"./configurator/layout/urban.png": 28032,
	"./configurator/menu/babylon-grouped.png": 11085,
	"./configurator/menu/babylon-horizontal.png": 73557,
	"./configurator/menu/babylon-inline.png": 22619,
	"./configurator/menu/babylon-light.png": 15486,
	"./configurator/menu/babylon-overlay.png": 11162,
	"./configurator/menu/babylon-popup.png": 66774,
	"./configurator/menu/babylon-rtl.png": 52463,
	"./configurator/menu/babylon-slim.png": 72093,
	"./configurator/menu/babylon-static.png": 71437,
	"./configurator/menu/babylon-ungrouped.png": 2859,
	"./confimea-imprese.png": 5913,
	"./confimea-model.pdf": 72719,
	"./confimeaCardPattern.png": 95534,
	"./customer-section-img.png": 46050,
	"./dashboard/antalya.png": 89339,
	"./dashboard/bg-header.png": 77679,
	"./dashboard/icon-checkin.png": 24819,
	"./dashboard/icon-sales.png": 73712,
	"./dashboard/icon-users.png": 73889,
	"./dashboard/icon-views.png": 13066,
	"./dashboard/image-1.png": 94524,
	"./dashboard/image-2.png": 72008,
	"./dashboard/image-3.png": 90922,
	"./elo.png": 60097,
	"./employeeSpotlightTabs.png": 32924,
	"./exclusive-background.png": 42723,
	"./expressoAmericano.png": 50186,
	"./extensions/asset-amex.png": 60023,
	"./extensions/asset-beginner.png": 61341,
	"./extensions/asset-enterprise.png": 57206,
	"./extensions/asset-mastercard.png": 14765,
	"./extensions/asset-paypal.png": 55974,
	"./extensions/asset-pro.png": 85810,
	"./extensions/asset-visa.png": 24855,
	"./extensions/avatar-1.png": 25717,
	"./extensions/avatar-2.png": 19054,
	"./extensions/avatar-3.png": 42649,
	"./extensions/babylon-icon.png": 47066,
	"./extensions/background.jpg": 12565,
	"./extensions/bg-header-2.png": 58294,
	"./extensions/bg-header-3.png": 36906,
	"./extensions/bg-header.png": 17893,
	"./extensions/prime-logo.svg": 66362,
	"./extensions/rectangle.jpg": 2473,
	"./importproducts/aliexpress.png": 3613,
	"./importproducts/amazon.png": 66105,
	"./importproducts/amazon.png~": 1804,
	"./importproducts/magento.png": 62001,
	"./importproducts/prestashop.png": 35627,
	"./importproducts/shopify.png": 24898,
	"./importproducts/woocommerce.png": 77140,
	"./landing/MockupEspanhol.png": 73002,
	"./landing/MockupIngles.png": 38600,
	"./landing/MockupItaliano.png": 67803,
	"./landing/MockupPortugues.png": 81272,
	"./landing/QRcode.jpeg": 12993,
	"./landing/about-section.jpg": 92060,
	"./landing/alert-chat-icon.svg": 52412,
	"./landing/alert-phone-icon.svg": 70952,
	"./landing/appstore_badge.svg": 99536,
	"./landing/asset-mackup-big.png": 42047,
	"./landing/asset-mackup.png": 28758,
	"./landing/asset-mackup@2x.png": 93301,
	"./landing/asset-mackup@3x.png": 87566,
	"./landing/babylon-icon-cta.png": 31327,
	"./landing/backpack.jpg": 63401,
	"./landing/benefitsCheck.png": 88729,
	"./landing/business.jpg": 7592,
	"./landing/card-icon.svg": 31655,
	"./landing/cashback-icon.svg": 71769,
	"./landing/chat-alert-blue.svg": 93634,
	"./landing/digital-sub-icon.svg": 52340,
	"./landing/ecobag.jpg": 98954,
	"./landing/economy-icon.svg": 69554,
	"./landing/graph-icon.svg": 4326,
	"./landing/icon-craftedforyou.svg": 1812,
	"./landing/icon-ellipsis-v.svg": 81872,
	"./landing/icon-gorgeous.svg": 78477,
	"./landing/icon-moderndesign.svg": 72884,
	"./landing/icon-responsivelayout.svg": 60640,
	"./landing/icon-welldocumented.svg": 82743,
	"./landing/laptop.jpg": 62537,
	"./landing/money-header-icon.svg": 6930,
	"./landing/money-icon.svg": 37759,
	"./landing/newphotos/customer-foto.jpg": 42412,
	"./landing/newphotos/esg-empresa.jpg": 1787,
	"./landing/newphotos/hero-mercado.jpg": 95771,
	"./landing/newphotos/manager-foto.jpg": 10339,
	"./landing/newphotos/negocio-padaria.jpg": 28775,
	"./landing/newphotos/partner-foto.jpg": 22808,
	"./landing/newphotos/promotor-foto.jpg": 82762,
	"./landing/newphotos/recursos-entrega.jpg": 94910,
	"./landing/newphotos/seller-foto.jpg": 13646,
	"./landing/newphotos/store-foto.jpg": 54288,
	"./landing/phone-copy-blue.svg": 17462,
	"./landing/phone-icon.svg": 23136,
	"./landing/places-icon.svg": 41580,
	"./landing/prev-icon.svg": 56567,
	"./landing/renegotiation-icon.svg": 9196,
	"./landing/shape.svg": 88103,
	"./landing/svg/facebook-logo": 64775,
	"./landing/svg/facebook-logo.js": 64775,
	"./landing/svg/telegram-logo": 22860,
	"./landing/svg/telegram-logo.js": 22860,
	"./landing/svg/whatsapp-logo": 59046,
	"./landing/svg/whatsapp-logo.js": 59046,
	"./landing/telegram-qrcode.png": 26797,
	"./landing/transfer-icon.svg": 74823,
	"./landing/whatsapp-qrcode.png": 16652,
	"./landing/work-with-us.png": 3691,
	"./landing/wtts-blue.svg": 17944,
	"./lines-phone.png": 46933,
	"./logo-black-horizontal.png": 85758,
	"./logo-black-notext.png": 67985,
	"./logo-black-vertical.png": 78794,
	"./logo-color-horizontal.png": 69852,
	"./logo-color-notext.png": 60002,
	"./logo-color-vertical.png": 69552,
	"./logo-green-horizontal.png": 42884,
	"./logo-iospedisco.png": 45281,
	"./logo-white-horizontal.png": 68900,
	"./logo-white-notext.png": 85271,
	"./logo-white-vertical.png": 80268,
	"./masterCard.png": 96356,
	"./nft.png": 37919,
	"./noResults.png": 72102,
	"./og_img.png": 58938,
	"./pagamentoSeguro.png": 47456,
	"./pages/ad-banner1.png": 27662,
	"./pages/appstore_badge.svg": 99852,
	"./pages/banner-sample.png": 59780,
	"./pages/bg-access.jpg": 54775,
	"./pages/bg-error.jpg": 51314,
	"./pages/bg-help.png": 43157,
	"./pages/bg-login.jpg": 9721,
	"./pages/bg-notfound.jpg": 83907,
	"./pages/corner-down-right.svg": 60289,
	"./pages/customer-register-bg.webp": 26633,
	"./pages/googleplay_badge.png": 28087,
	"./pages/help/blog1.jpg": 10267,
	"./pages/help/blog2.jpg": 97398,
	"./pages/help/blog3.jpg": 83713,
	"./pages/icon-design.svg": 99835,
	"./pages/icon-devices.svg": 46265,
	"./pages/icon-diamond.svg": 47242,
	"./pages/icon-document.svg": 556,
	"./pages/laptop-product.png": 18329,
	"./pages/login-img.jpg": 16720,
	"./pages/login-pattern.png": 54649,
	"./pages/promoter-register-bg.webp": 38106,
	"./pages/smartphone-product.png": 90907,
	"./pages/stars.png": 46051,
	"./parcerias/attiva-piu.png": 69879,
	"./parcerias/benesse.png": 27443,
	"./parcerias/confirmea.jpg": 44837,
	"./parcerias/cryptosmart.jpg": 12900,
	"./parcerias/fondoSanMarco.jpg": 26755,
	"./parcerias/grupoG8.jpg": 89975,
	"./parcerias/jimmyk.png": 828,
	"./parcerias/maticom.png": 75081,
	"./parcerias/ods.png": 28722,
	"./paypal.png": 87322,
	"./plans/plansDeCompesation.pdf": 60445,
	"./plans/plansES.pdf": 65791,
	"./plans/plansIT.pdf": 1860,
	"./plans/plansPT.pdf": 54768,
	"./posteItalianeLogo.png": 95493,
	"./salepromoter/salepromoter-bg.jpg": 23720,
	"./salepromoter/salepromoter-bg.jpg~": 57431,
	"./sort-icon-down.svg": 26239,
	"./sort-icon-up.svg": 85492,
	"./sort-icon.svg": 33561,
	"./specialcustomer/specialcustomer-bg.jpg": 94183,
	"./specialcustomer/specialcustomer-bg.jpg~": 61373,
	"./underconstruction/underconstruction.jpg": 28076,
	"./visa.png": 32299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75613;